<template>
    <div class="grid-cols-12 lg:grid">
        <div class="overflow-hidden relative w-full rounded lg:block lg:col-span-7 lg:min-h-135">
            <img v-if="currentImage"
                 :src="currentImage"
                 :alt="currentImageAlt"
                 class="object-cover object-center absolute top-0 left-0 w-full h-full hidden:block">
            <slot name="image" v-else />
        </div>
        <div class="flex-col justify-center lg:col-span-4 lg:col-start-9 lg:flex">
            <slot />
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Provide } from 'vue-property-decorator';
import AccordionTeaserItem from './AccordionTeaserItem.vue';

@Component
export default class AccordionTeaser extends Vue {
    @Provide('register') childRegistration = this.registerItem;

    items: AccordionTeaserItem[] = [];
    currentImage = '';
    currentImageAlt = '';

    registerItem(item: AccordionTeaserItem) {
        this.items.push(item);
        item.group = `${this._uid}`;
        item.$on('open', this.onAccordionOpened);
        if (this.$children.filter(this.filterItems).length === this.items.length && this.items.length > 0) {
            // all items registered -> open first one
            setTimeout(() => {
                this.items[0].open();
            }, 400);
        }
    }

    filterItems(child: Vue) {
        return child.$vnode && child.$vnode.componentOptions && child.$vnode.componentOptions.tag === 'accordion-teaser-item';
    }

    onAccordionOpened(imageUrl: string, title: string) {
        this.currentImage = imageUrl;
        this.currentImageAlt = title;
    }
}
</script>
